<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Readers love </span><span class="t2">B</span><span class="t3">RANDON</span><span class="t2"> W</span><span class="t3">ITT</span></p>
<p class="p2"><span class="t4">The Shattered Door</span></p>
<p class="p3">“What an incredibly well written emotional story, as if you haven’t already guessed HA! It really is quite a journey our Brooke goes on, one which I strongly encourage everyone to read. It’ll hurt, it’ll make you question, yet it will also bring home the importance of respect, decency, the good that exists and the importance of faith, whatever that might be, and importantly it brings home hope. It will also make you smile through tears and chuckle a few times too at the sarcasm and irony. It was passionate, intense, beautiful and poignant.”</p>
<p class="p4">—Totally Booked Blog</p>
<p class="p5">“Wow.  Need something more than that?  How about… go buy this book!”</p>
<p class="p4">—Prism Book Alliance</p>
<p class="p3"><span class="t3">Men of Myth series</span></p>
<p class="p3">“<span class="t6">Clashing Tempest</span> is a must read for anyone who read the first two Men of Myth books. And if you haven’t, pick up all three ASAP!!!”</p>
<p class="p4">—The Novel Approach</p>
<p class="p3">“Men of Myth series is hands down one of the best paranormal / fantasy series I have ever had the pleasure of reading.”</p>
<p class="p4">—On Top Down Under Reviews</p>
<p class="p3">“If you want to spend an afternoon reading an enthralling, entertaining, and satisfying tale, then I recommend that you check this one out for yourself.”</p>
<p class="p4">—Mrs. Condit and Friends Read Books</p>
<p class="p3"> “Again the masterful story teller and evil, evil, evil Mr. Witt has left us with a cliffhanger making you want to immediately pick up the next book in the series.”</p>
<p class="p6">—World of Diversity Fiction</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?0b0c2005